import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ACTION_TYPES } from '../../../../utils/const/mpProducts';

const ConfirmActionModal = ({
  open,
  onCancel,
  onConfirm,
  actionType,
  productCount,
  loading = false,
}) => {
  const { t } = useTranslation(['common']);

  const getModalConfig = () => {
    switch (actionType) {
      case ACTION_TYPES.REMOVE:
        return {
          title: t('common:confirm-remove-from-category'),
          content: t('common:confirm-remove-from-category-description', {
            count: productCount,
          }),
          okText: t('common:yes'),
          cancelText: t('common:no'),
          okType: 'danger',
        };
      case ACTION_TYPES.TRANSFORM:
        return {
          title: t('common:confirm-transform'),
          content: t('common:confirm-transform-description', {
            count: productCount,
          }),
          okText: t('common:yes'),
          cancelText: t('common:no'),
          okType: 'primary',
        };
      case ACTION_TYPES.BROADCAST:
        return {
          title: t('common:confirm-broadcast'),
          content: t('common:confirm-broadcast-description', {
            count: productCount,
          }),
          okText: t('common:yes'),
          cancelText: t('common:no'),
          okType: 'primary',
        };
      case ACTION_TYPES.REMOVE_ONE_FROM_CATEGORY:
        return {
          title: t('common:confirm-remove-one-from-category'),
          content: t('common:confirm-remove-one-from-category-description', {
            count: productCount,
          }),
        };
      case ACTION_TYPES.PUBLISH_ONE:
        return {
          title: t('common:confirm-publish-one'),
          content: t('common:confirm-publish-one-description', {
            count: productCount,
          }),
        };
      case ACTION_TYPES.TRANSFORM_ONE:
        return {
          title: t('common:confirm-transform-one'),
          content: t('common:confirm-transform-one-description', {
            count: productCount,
          }),
        };
      default:
        return {
          title: t('common:confirm'),
          content: '',
          okText: t('common:yes'),
          cancelText: t('common:no'),
        };
    }
  };

  const config = getModalConfig();

  return (
    <Modal
      open={open}
      title={config.title}
      onOk={onConfirm}
      onCancel={onCancel}
      okText={config.okText}
      cancelText={config.cancelText}
      okType={config.okType}
      confirmLoading={loading}
    >
      <p>{config.content}</p>
    </Modal>
  );
};

export default ConfirmActionModal;
